// extracted by mini-css-extract-plugin
export default {"label":"EmployeeCheckboxLabel--label--87a98c","avatar":"EmployeeCheckboxLabel--avatar--e48213"};